import { interactionEvent } from 'lib/analytics/gtmEventShapes';
import { openPointsClubModal } from 'store/ui/uiActions';
import { getPageFromState } from './helpers';
import { getIsAuthenticated } from 'store/user/userSelectors';

const qhSearchPage = 'QH Search Page';
const qhPropertyPage = 'QH Property Page';
const qhCheckoutPage = 'QH Booking Page';
const qhBookingConfirmationPage = 'QH Booking Confirmation Page';

const eventTypes = {
  [qhSearchPage]: {
    qff: 'Points Club Welcome Banner',
    guest: 'Points Club Login Banner',
  },
  [qhPropertyPage]: {
    qff: 'Points Club Welcome Banner',
    guest: 'Points Club Login Banner',
  },
  [qhCheckoutPage]: {
    qff: 'Points Club Note',
    guest: '',
  },
  [qhBookingConfirmationPage]: {
    qff: 'Points Club Earned Banner',
    guest: '',
  },
};

const emitOpenPointsClubModalEvent = (_, prevState) => {
  const pageName = getPageFromState(prevState).name;

  const isAuthenticated = getIsAuthenticated(prevState);

  const accountType = isAuthenticated ? 'qff' : 'guest';
  const eventType = eventTypes?.[pageName]?.[accountType];

  if (eventType) {
    return interactionEvent({ type: eventType, value: 'Points Club Modal Opened', page: pageName });
  }
};

export default { [openPointsClubModal]: emitOpenPointsClubModalEvent };
